import { CLAIMSTATUS_INIT_SUCCESS, CLAIMSTATUS_INIT_FAIL, CLAIMSTATUS_INIT_LOADING, CLAIMSTATUS_COMMIT_KEY } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  clmStatus: {
    clmStatus: null
  }
}

const getters = {
}

const mutations = {
  [CLAIMSTATUS_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [CLAIMSTATUS_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [CLAIMSTATUS_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [CLAIMSTATUS_COMMIT_KEY](state, data) {
    state.clmStatus.clmStatus = data.claimStatus
  }
}

const actions = {
  async claimStatusManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.claimStatusManagement
    commit(CLAIMSTATUS_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(CLAIMSTATUS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(CLAIMSTATUS_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
